import { Alert } from '@mui/material';
import React from 'react';

function Toast({ closeToast, data: { message, severity } }) {
  return (
    <Alert severity={severity} onClose={closeToast}>
      {message}
    </Alert>
  );
}

export default Toast;
